const e=async(e,t,n,r,i)=>{await e.put(`/apps/${t}/orgs/${n}`,{...r===void 0?{}:{seedDefaultRoles:r},...i===void 0?{}:{seats:i}})};export{e as assignApp};
//# sourceMappingURL=assign-app.mjs.map